import React from 'react'
import InputAdornment from '@mui/material/InputAdornment'
import CircularProgress from '@mui/material/CircularProgress'
import SearchIcon from '@mui/icons-material/Search'
import TextField from '@mui/material/TextField'

const SearchInput = ({
    label,
    value,
    onChange,
    autoFocus = false,
    isLoading = false,
    sx,
    ...rest
}) => (
    <TextField
        label={label}
        value={value}
        autoFocus={autoFocus}
        onChange={onChange}
        sx={sx}
        InputProps={{
            endAdornment: (
                <InputAdornment position="start">
                    {isLoading ? (
                        <CircularProgress size={25} />
                    ) : (
                        <SearchIcon />
                    )}
                </InputAdornment>
            ),
        }}
        {...rest}
    />
)

export default SearchInput
